export default __webpack_public_path__ + "static/media/Merriweather-Regular.55c73e48.ttf";